import React from "react";
import { Box } from "@mui/material";
import Layout from "../Layout";

const PageContainer = ({ children, maxWidth = 1400, noPadding = false }) => {
  return (
    <Layout>
      <Box
        sx={{
          minHeight: "calc(100vh - 140px)",
          bgcolor: "#f5f7fb",
          p: noPadding ? 0 : { xs: 1, sm: 3 },
          overflowX: "hidden",
        }}
      >
        <Box sx={{ maxWidth, mx: "auto", overflowX: "hidden" }}>{children}</Box>
      </Box>
    </Layout>
  );
};

export default PageContainer;
